"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Error = require("./Error.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ErrorMessage = ({
  text,
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_Error.StyledMessage, props, children ? children : text);

exports.ErrorMessage = ErrorMessage;
ErrorMessage.propTypes = {
  text: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};